module.exports = __webpack_public_path__ + "static/media/5D.24fd440c.png";